import QuotationTabs from "./quotation-tabs.container";

export default QuotationTabs;
